import { getTodaysDate } from '../util/commonUtil';
import client from './TokenInterceptorServices';

const todaysDate = getTodaysDate();

export const getPlYearlyMetrics = async (YEAR, EMAIL, DATE) => {
  const URL = `/opportunity/yearlymetrics?year=${YEAR}&email=${EMAIL}&date=${DATE}`;
  try {
    const response = await client.get(URL);
    return response.data[0];
  } catch (error) {
    throw error;
  }
};

// Abonded API
export const getOpportunitiesDue = async (ROLE, EMAIL) => {
  // Email Required *
  const URL = `/opportunity/date/${todaysDate}?role=${ROLE}&email=${EMAIL}`;

  try {
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getOpportunitiesDetails = async EMAIL => {
  try {
    let URL = `/opportunity/pl/details?email=${EMAIL}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getQuaterlyDetails = async (EMAIL, START_DATE, END_DATE) => {
  try {
    let URL = `/opportunity/pl/quaterlydetails?email=${EMAIL}&start_date=${START_DATE}&end_date=${END_DATE}`;
    const response = await client.get(URL);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const submitopportunity = async (MONTH, YEAR, QUARTER, REQ_BODY, EMAIL) => {
  // Email Required *
  try {
    const URL = `/opportunity/pl/submitopportunity?month=${MONTH}&year=${YEAR}&quarter=${QUARTER}&email=${EMAIL}`;
    const response = await client.post(URL, REQ_BODY, {
      headers: {
        'Content-Type': 'application/json',
      },
      // timeout: 5000 // Set a timeout of 5 seconds
    });
    return { msg: 'Submit Successfully :', data: response.data };
  } catch (error) {
    console.log('Error while submitting : ', error);
    throw error;
  }
};

export const getMyDashboardData = async (YEAR, EMAIL, DATE) => {
  try {
    const URL = `/opportunity/plDashboardStats?year=${YEAR}&email=${EMAIL}&date=${DATE}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const subHeaderPLPastQtrDetails = async (QUARTER, YEAR, EMAIL) => {
  // Email Required *
  try {
    let URL = `/opportunity/quarter/${QUARTER}?year=${YEAR}&email=${EMAIL}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const subHeaderPLPastMonthDetails = async (QUARTER, MONTH, YEAR, EMAIL) => {
  // Email Required *
  try {
    let URL = `/opportunity/quarter/${QUARTER}?year=${YEAR}&month=${MONTH}&email=${EMAIL}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const pastMonthlyopportunitiesPL = async (EMAIL, YEAR, QUARTER, MONTH) => {
  try {
    let URL = `/opportunity/pl/pastdetails?email=${EMAIL}&year=${YEAR}&quarter=${QUARTER}&month=${MONTH}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const pastQuaterlyopportunitiesPL = async (EMAIL, YEAR, QUARTER) => {
  try {
    let URL = `/opportunity/pl/pastdetails?email=${EMAIL}&year=${YEAR}&quarter=${QUARTER}&month=null`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getFutureCalculationByYear = async (EMAIL, YEAR) => {
  try {
    let URL = `/opportunity/getFutureCalculationByYear?year=${YEAR}&email=${EMAIL}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const submitopportunityV2 = async (MONTH, YEAR, QUARTER, REQ_BODY, EMAIL) => {
  try {
    const response = await client.post(`/opportunity/pl/updatecrm?email=${EMAIL}`, {
      crm_update: REQ_BODY.crm_update,
    });

    if (response.status === 200) {
      const promises = [
        client.post(
          `/opportunity/pl/capturesnap?month=${MONTH}&year=${YEAR}&quarter=${QUARTER}&email=${EMAIL}`,
          {
            crm_quaterly_response: REQ_BODY.crm_quaterly_response,
            crm_update: REQ_BODY.crm_update,
            forecast_table_details: REQ_BODY.forecast_table_details,
            snap_dates: REQ_BODY.snap_dates,
          },
        ),
        client.post(
          `/opportunity/pl/capturerollingsnap?month=${MONTH}&year=${YEAR}&quarter=${QUARTER}&email=${EMAIL}`,
          {
            crm_response: REQ_BODY.crm_full_res,
            crm_update: REQ_BODY.crm_update,
            forecast_table_details: REQ_BODY.forecast_table_details,
            rolling_dates: REQ_BODY.rolling_dates,
          },
        ),
        client.post(
          `/opportunity/pl/updateforecasttable?month=${MONTH}&year=${YEAR}&quarter=${QUARTER}&email=${EMAIL}`,
          {
            forecast_table_details: REQ_BODY.forecast_table_details,
          },
        ),
      ];
      const results = await Promise.all(
        promises.map(promise => promise.catch(error => ({ error }))),
      );
      if (
        results.length !== 0 &&
        results[0].status === 200 &&
        results[1].status === 200 &&
        results[2].status === 200
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const getNowNextBeyondSidebarData = async (DATA_TITLE, EMAIL, DATE, YEAR, QUARTER) => {
  try {
    const URL =
      DATA_TITLE === 'beyond'
        ? `opportunity/pl/sidebar/${DATA_TITLE}?email=${EMAIL}&date=${DATE}&year=${YEAR}&quarter=${QUARTER}`
        : `opportunity/pl/sidebar/${DATA_TITLE}?email=${EMAIL}&date=${DATE}&year=${YEAR}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const pastSidebarPL = async (EMAIL, YEAR, QUARTER, DATE) => {
  try {
    let URL = `/opportunity/pl/dashboard/quaterly?email=${EMAIL}&year=${YEAR}&quarter=${QUARTER}&date=${DATE}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};
